import 'owl.carousel/dist/assets/owl.carousel.css!';
import 'owl.carousel';

class HomeSlider {

  constructor(){
    this.slider = jQuery('#js--home-avis-slider');
    this._init();
  }

  _init(){
    document.addEventListener('DOMContentLoaded', (event) => {

      if( this.slider[0] ){
        
        this.slider.owlCarousel({
          items:                 1,
          nav:                   true,
          navText:               ['',''],
          navContainerClass:     'owl-nav-home',
          dots:                  false,
          autoplay:           true,
          loop: true,
          // autoplayTimeout:    5000,
          // autoplayHoverPause: false,
          // autoHeight:         false,
        });

      }  

    });
  }

}

export const homeSlider = new HomeSlider();